import { FramingSelection } from '../../../components/Checkout/Framing/types';
import { GeneratedOrderItem } from '../../../types/generated';
import { Frame } from '../../../types/Products';
import { shopifyGraphqlIdToAdminId } from '../../../utils/shopifyIds';

type OrderItemList =
  | (GeneratedOrderItem | null | undefined)[]
  | null
  | undefined;

const frameToOrderItem = (frame: Frame): GeneratedOrderItem => {
  const [consolidated] = frame.variant.consolidatedVariants;

  return {
    productID: shopifyGraphqlIdToAdminId(consolidated.shopifyFrameId),
    variantID: shopifyGraphqlIdToAdminId(consolidated.shopifyFrameVariantId),
    quantity: 1,
    sku: consolidated.sku ?? null,
  };
};

export const buildFrameOptionalItems = (
  frame: FramingSelection,
): GeneratedOrderItem[] => {
  return frame ? [frameToOrderItem(frame)] : [];
};

const sameOrderItem = (
  a: GeneratedOrderItem | null | undefined,
  b: GeneratedOrderItem | null | undefined,
): boolean => {
  if (!a || !b) {
    return !a && !b;
  }

  return (
    a.productID === b.productID &&
    a.variantID === b.variantID &&
    a.quantity === b.quantity &&
    (a.sku ?? null) === (b.sku ?? null)
  );
};

export const sameOrderItems = (a: OrderItemList, b: OrderItemList): boolean => {
  const itemsA = a ?? [];
  const itemsB = b ?? [];

  return (
    itemsA.length === itemsB.length &&
    itemsA.every((item, index) => {
      return sameOrderItem(item, itemsB[index]);
    })
  );
};
